module.exports = require("@noble/ed25519");